import SimpleTable from 'components/Tables/SimpleTable';
import React from 'react';
import { connect } from 'react-redux';
import { groupBy, mixtureSubstancesBySubstance } from 'selectors/generic';
import theme from 'source/theme';

const columnsBase = [
  { title: 'Código MP', field: 'mixture_code' },
  { title: 'MP', field: 'mixture_name' },
  { title: 'Código', field: 'code' },
  { title: 'Produto', field: 'name' },
  { title: 'Papel Reach', field: 'reach_role' }
];

// `rm.products` - the products a raw material is in. The m2m sent one id per
// composition row, so a raw material that enters the same product twice was
// sent twice; the Set is what removed the repeats and still does.
const productIdsOf = composition => Array.from(new Set(composition.map(row => row.product_id)));

const Component = props => {
  const {
    columns = columnsBase, compositionOfRawMaterial, mixturesOfSubstance, productsById,
    rawMaterialsById, rowData, title
  } = props;

  const composition = compositionOfRawMaterial[rowData.id] || [];

  // Direct Products for the substance
  let products = [];
  if (rowData.code && rowData.code !== '') {
    productIdsOf(composition).forEach(productId => {
      // "Does this raw material go into that product on its own, rather than
      // inside a mixture". It used to read the product's composition rows and
      // look for this raw material; the same row is in this raw material's
      // composition rows, named from the other side.
      const isRMOnCarga = composition.find(pmp =>
        pmp.product_id === productId && !pmp.mixture_id
      );

      if (isRMOnCarga) {
        products.push(productsById[productId]);
      }
    });
  }

  // Indirect Products in case it is a Substance used in Mixtures
  (mixturesOfSubstance[rowData.id] || []).forEach(interMixture => {
    const mixture = rawMaterialsById[interMixture.mixture_id];
    const productsIds = productIdsOf(compositionOfRawMaterial[mixture.id] || []);
    const mixtureProducts = productsIds.map(productId => ({
        ...productsById[productId],
        mixture_code: mixture.code,
        mixture_name: mixture.name
      })
    );
    products = [...products, ...mixtureProducts];
  });

  return (
    <div style={{ padding: 10, backgroundColor: theme.palette.background.light }}>
      <SimpleTable columns={columns} rows={products} title={title}/>
    </div>
  );
};

const compositionByRawMaterial = groupBy('productRawMaterials', 'raw_material_id');

const mapStateToProps = state => ({
  compositionOfRawMaterial: compositionByRawMaterial(state),
  mixturesOfSubstance: mixtureSubstancesBySubstance(state)
});

export default connect(mapStateToProps)(Component);
